import React, { useEffect } from "react";
import { useForm } from "react-hook-form";
import { useRecoilState, useSetRecoilState, useRecoilValue } from "recoil";
import { trialState } from "../../recoil/record";
import useAuthActions from "../../api/hooks/admin/auth";
import { applyStepState } from "../../recoil/pageStep";
import InputText from "../atoms/input/InputText";
import FooterButtonGroup from "../modules/layout/FooterButtonGroup";
import Header from "../modules/layout/Header";
import { logoURL, userData } from "./ApplyRouter";
import { ApplyStep } from "./ApplyRouter";
import { authState } from "recoil/auth";
import { useMutation, useQuery } from "@tanstack/react-query";
import useExamRoomActions from "../../api/hooks/admin/examRoom";
import { useParams, useSearchParams } from "react-router-dom";
import useExamActions from "../../api/hooks/exam";
import useApiActions from "../../recoil/api";

const LoginForm = () => {
  const setApplyStep = useSetRecoilState(applyStepState);
  const { applyLogin, applyPass } = useAuthActions();
  const [auth, setAuth] = useRecoilState(authState);
  const trial = useRecoilValue(trialState);
  const { uuid } = useParams();
  
  const [searchParams, setSearchParams] = useSearchParams();

  const uid = searchParams.get("uid");
  useEffect(() => {
    if (uid) {
      const req = { group_uuid: uuid, uid: uid };
      doPassLogin.mutate(req);
    }
  }, []);

  const { setLog } = useApiActions();
  const examActions = useExamActions();

  const {
    register,
    handleSubmit,
    formState: { errors },
  } = useForm();

  const onSubmit = (data) => {
    const req = { ...data, group_uuid: uuid };
    mutation.mutate(req);
  };

  const getExamList = async ({ questionIndex }) => {
    const res = await examActions.getExamList({
      examNumber: questionIndex,
    });

    if (res?.status === 400 && res?.data.status === 453) {
      alert("모든 문항을 응시했습니다.");
    }
  };

  const mutation = useMutation(applyLogin, {
    onSuccess: (context) => {
      // type 관리자:0 평가자:1 응시자:2
      if (context.status === 200) {
        if (context.data.finish_check === true) {
          setApplyStep(ApplyStep.RESULT);
          setLog({
            params: {
              text: `step ${ApplyStep.RESULT}`,
            },
          });
        } else if (context) {
          setApplyStep((old) => {
            setLog({
              params: {
                text: `step ${old} => ${old + 1}`,
              },
            });
            return old + 1;
          });
        } else {
          alert("입력하신 정보가 일치하지 않습니다.");
        }
      }
    },
    onError: (error) => {
      alert(error.message);
    },
  });

  const doPassLogin = useMutation(applyPass, {
    onSuccess: (context) => {

      if (context.status === 200) {
        if (context.data.finish_check === true) {
          setApplyStep(ApplyStep.RESULT);
          setLog({
            params: {
              text: `step ${ApplyStep.RESULT}`,
            },
          });
        } else if (context) {
          setApplyStep((old) => {
            if (trial) {
              setLog({
                params: {
                  text: `step ${old} => 6`,
                },
              });
              return 6;
            } else {
              setLog({
                params: {
                  text: `step ${old} => ${old + 1}`,
                },
              });
              return old + 1;
            }
          });
        } else {
          alert("사용자 정보를 찾을 수 없습니다.");
        }
      }
    },
    onError: (error) => {
      alert(error.message);
    },
  });

  return (
    <form onSubmit={handleSubmit(onSubmit)}>
      <div className="base-sec-sec">
        <div className="login-welcome">
          {/* <div className="main_logo"></div> */}
          <img
            className="main_logo_img"
            src="../../../../img/khcp/khcp_logo.png"
            style={{ width: "250px", height: "auto" }}
          />
          <p className="login-title none d-block">로그인</p>
        </div>
        <div className="login-active">
          <div className="login-id">
            <p className="login-title">이름</p>
            <InputText
              className="login-input"
              refs={{
                ...register("name"),
              }}
            />
          </div>

          <div className="login-password">
            <p className="login-title">평가응시 코드</p>
            <InputText
              className="login-input"
              refs={{
                ...register("code"),
              }}
            />
          </div>
          <p className="login-comment">
            *평가응시코드는 접수 시 입력한 이메일을 통하여 발송되었습니다.{" "}
          </p>
        </div>
        <div className="text-align-center">
          <p className="next-text">
            응시자 본인의 이름과 평가응시코드를 입력 후 “다음”을 선택하세요
          </p>
        </div>
      </div>
      <FooterButtonGroup
        prevOnClick={() => setApplyStep((old) => old - 1)}
        nextButtonType="submit"
      />
    </form>
  );
};

// View
const ApplyLogin = () => {
  const setApplyStep = useSetRecoilState(applyStepState);
  const { setLog } = useApiActions();

  const prevOnClick = () => {
    setApplyStep((old) => {
      setLog({
        params: {
          text: `step ${old} => ${old - 1}`,
        },
      });
      return old - 1;
    });
  };

  useEffect(() => {});

  return (
    <div>
      <Header />
      <div className="base-sec login-sec">
        <div className="background-color-w">
          <div className="base-sec-top flex">
            <div>
              <p className="title">영어 말하기 평가</p>
            </div>
          </div>
          <LoginForm prevOnClick={prevOnClick} />
        </div>
      </div>
    </div>
  );
};

export default ApplyLogin;
